<template>
  <section class="about">
    <za-banner></za-banner>
    <article class="article">
      <img class="article-img" src="../assets/img/phone3-icon.png" alt="">
      <div class="article-item" v-for="item in list" :key="item.name">
        <h3>{{ item.name }}</h3>
        <p>职责:</p>
        <ul>
          <li v-for="duty in item.duty" :key="duty">
            <span></span>
            {{ duty }}
          </li>
        </ul> 
      </div>
    </article>
  </section>
</template>

<script>
import zaBanner  from '@/components/Banner.vue'
export default {
  components: {
    zaBanner
  },
  props: {},
  data () {
    return {
      list: [
        {name: '技术部门', duty: [
          '负责技术架构的设计和优化，保证系统的高效性和可扩展性。',
          '负责应用系统的开发和编码工作。',
          '负责应用系统的测试和质量保证工作，确保系统的稳定性和可靠性。'
        ]},
        {name: '运营部门', duty: [
          '负责制定运营策略和规划，协调各个子团队的工作，确保运营目标的实现。',
          '负责收集和分析用户数据，提供运营决策支持。'
        ]},
        {name: '销售部门', duty: [
          '负责制定销售策略和规划，领导和管理销售团队。',
          '负责与客户进行销售沟通和业务洽谈，促成交易。'
        ]},
      ]
    }
  },
  watch: {},
  computed: {},
  methods: {},
  created () {},
  mounted () {}
}
</script>
<style scoped>
.article{
  padding: 5% 88px;
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
}
.article-img{
  position: absolute;
  top: 8%;
  right: 5%;
  height: 300px;
  border-radius: 50px;
  z-index: 1;
}
.article-item{
  width: 411px;
  margin-bottom: 80px;
}
.article-item h3{
  font-family: Source Han Sans CN;
  font-weight: 500;
  font-size: 36px;
  color: #333333;
  margin-bottom: 30px;
}
.article-item p, ul{
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 24px;
  color: #333333;
  line-height: 50px;
}

.article-item p, ul li{
  position: relative;
}

.article-item ul li::before{
  content:'';
  position: absolute;
  top: 20px;
  left: -20px;
  width: 12px;
  height: 12px;
  background: #388CF4;
  border-radius: 50%;
}
</style>